import React from "react";
import Heading from "../Heading";
import { ReImagineStyles } from "../Styles";
import GlobalSubHeading from "../GlobalSubHeading";
import PeopleIcon from "@mui/icons-material/People";
import PublicIcon from "@mui/icons-material/Public";
import { getMeaning } from "../../utils/localization";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Box, Grid, Card, Container, Typography } from "@mui/material";

const FEATURES = [
  {
    icon: <AttachMoneyIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.ONESTPSOL1"),
    description: getMeaning("HME.ONESTPSOL2"),
  },
  {
    icon: <AttachMoneyIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.INCRSD1"),
    description: getMeaning("HME.INCRSD2"),
  },
  {
    icon: <TrendingUpIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.CMPLNG1"),
    description: getMeaning("HME.CMPLNG2"),
  },
  {
    icon: <PeopleIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.SATSFCTN1"),
    description: getMeaning("HME.SATSFCTN2"),
  },
  {
    icon: <PublicIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.GLBLRCH1"),
    description: getMeaning("HME.GLBLRCH2"),
  },
  {
    icon: <PublicIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.ALRMCNTR1"),
    description: getMeaning("HME.ALRMCNTR2"),
  },
  {
    icon: <PublicIcon fontSize="large" color="primary" />,
    title: getMeaning("HME.EDGE1"),
    description: getMeaning("HME.EDGE2"),
  },
];

const ReImagineSuccess = () => {
  return (
    <Box sx={ReImagineStyles.root}>
      <Container maxWidth="lg">
        <Heading title={getMeaning("HME.REIMAGINHDNG")} />

        <Box align="center">
          <GlobalSubHeading subTitle={getMeaning("HME.REIMAGINSBHDNG")} />
        </Box>

        <Grid
          container
          sx={{ spacing: { xs: 0, md: 2 } }}
          style={{ marginTop: "40px", marginLeft: -40 }}
          justifyContent="center"
        >
          {FEATURES?.map((feature, index) => {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={4}
                key={index}
                sx={ReImagineStyles.gridItem}
              >
                <Box
                  style={{
                    height: 130,
                    // height: 150,
                    width: 360,
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        justifyContent: "start",
                      }}
                    >
                      <Box
                        sx={{
                          width: 2,
                          height: 22,
                          // backgroundColor: "#FF4500",
                          backgroundColor: "#cfd8dc",
                          position: "absolute",
                          left: 45,
                          top: 25, // 30
                        }}
                      />
                      <Box
                        sx={{
                          width: 65, // 65
                          height: 40, // 50
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#F4F6FA",
                          borderRadius: 3,
                          position: "absolute",
                          left: 35,
                          top: -45,
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                          position: "relative",
                          background:
                            "linear-gradient(white, white) padding-box, linear-gradient(45deg, #e0e0e0, #e0e0e0) border-box",
                          border: "2px solid transparent", // Transparent border to show gradient
                        }}
                      >
                        <Box>{feature?.icon}</Box>
                      </Box>

                      <Box
                        sx={{
                          width: 30,
                          height: 2,
                          // backgroundColor: "#FF4500",
                          backgroundColor: "#cfd8dc",
                          // marginTop: "5px",
                        }}
                      />

                      <Card
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px 20px",
                          width: "100%", // Ensure full width inside the grid
                          // maxWidth: 350, // Consistent width across all cards
                          minHeight: 70,
                          borderRadius: 3,
                          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.05)",
                          background:
                            "linear-gradient(white, white) padding-box, linear-gradient(45deg, #cfd8dc, #cfd8dc) border-box",
                          border: "2px solid transparent",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ fontSize: 14, fontFamily: '"Poppins", serif' }}
                        >
                          <b>{feature?.title} </b>
                          {feature?.description}
                        </Typography>
                      </Card>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default ReImagineSuccess;
